import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import AboutPSAOA from "@/components/AboutPSAOA";
import AdvertiseWithUs from "@/components/AdvertiseWithUs";
import ApartmentMarketplaceSection from "@/components/ApartmentMarketplaceSection";
import WhatPSAOADoes from "@/components/WhatPSAOADoes";
import LocationSection from "@/components/LocationSection";
import CommunitySnapshot from "@/components/CommunitySnapshot";
import GallerySection from "@/components/GallerySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FacilityManagement from "@/components/FacilityManagement";
import ExecutiveCommittee from "@/components/ExecutiveCommittee";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import ImportantNumbers from "@/components/ImportantNumbers";
import Footer from "@/components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <div className="section-divider"></div>
        <AboutSection />
        <div className="section-divider"></div>
        <AboutPSAOA />
        <div className="section-divider"></div>
        <AdvertiseWithUs />
        <div className="section-divider"></div>
        <ApartmentMarketplaceSection />
        <div className="section-divider"></div>
        <WhatPSAOADoes />
        <div className="section-divider"></div>
        <LocationSection />
        <div className="section-divider"></div>
        <CommunitySnapshot />
        <div className="section-divider"></div>
        <GallerySection />
        <div className="section-divider"></div>
        <TestimonialsSection />
        <div className="section-divider"></div>
        <FacilityManagement />
        <div className="section-divider"></div>
        <ExecutiveCommittee />
        <div className="section-divider"></div>
        <FAQSection />
        <div className="section-divider"></div>
        <ContactSection />
        <div className="section-divider"></div>
        <ImportantNumbers />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
